import React, { Component } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

class News extends Component {
	constructor(props) {
		super(props);
		this.state = {
			news: [
				<div>
					<h1 className='main' style={{ fontWeight: '800' }}>
						<i className='fa fa-spinner fa-spin' style={{ fontSize: '40px', color: 'purple' }} />
						&nbsp;&nbsp;Loading...
					</h1>
				</div>
			],
			type: ''
		};
		this.getNews = this.getNews.bind(this);
		this.setNews = this.setNews.bind(this);
	}

	componentWillMount() {
		var type = this.props.match.params.type;
		var code = this.props.match.params.code;
		var news = this.getNews(type, code);
	}

	async getNews(type, code) {
		const PROXY_URL = '' /* 'https://cors-anywhere.herokuapp.com/' */;
		const URL =
			'https://newsapi.org/v2/top-headlines?country=' +
			code +
			'&category=' +
			type +
			'&apiKey=196695bd02bf42cbb947c76831714c5e';
		var news = await axios.get(PROXY_URL + URL);
		/* var news = await axios.get(
			'https://newsapi.org/v2/top-headlines?country=' +
				code +
				'&category=' +
				type +
				'&apiKey=196695bd02bf42cbb947c76831714c5e'
		); */
		console.log(news.data.articles);
		this.setNews(news.data.articles);
		this.setState({
			type: type
		});
		return news.data.articles;
	}
	setNews(news) {
		if (news.length > 0) {
			this.setState({
				news: news.map((data, index) => {
					return (
						<li className='cards_item' id={index}>
							<div className='card'>
								<div style={{ color: 'black', fontSize: 'large', margin: '1%', fontWeight: '800' }}>
									{data.title}
								</div>
								<div className='card_image'>
									<img src={data.urlToImage} alt={index} />
								</div>
								<div className='card_content'>
									<h2
										className='card_title'
										style={{ borderBottom: '2px solid white', padding: '2px', fontSize: 'medium' }}
									>
										{data.description}
									</h2>
									<p
										className='card_text'
										style={{ borderBottom: '2px solid white', padding: '2px' }}
									>
										{data.content}
									</p>
									<p style={{ fontSize: '1.5rem', color: 'white', fontWeight: '600' }}>
										Published At&nbsp;:&nbsp;{data.publishedAt}
									</p>
									<p style={{ fontSize: '1.5rem', color: 'white', fontWeight: '600' }}>
										Source&nbsp;:&nbsp;{data.source.name}
									</p>
									<a href={data.url}>
										<button className='btn-primary' style={{ width: '80%' }}>
											Read More
										</button>
									</a>
								</div>
							</div>
						</li>
					);
				})
			});
		} else {
			this.setState({
				news: (
					<div>
						<img className='card_image' src={require('./images/notfound.jpg')} alt='not' />
						<h2 style={{ fontWeight: '800' }}>No Latest News Found In This Category !</h2>
					</div>
				)
			});
		}
	}

	render() {
		return (
			<div>
				<Navbar />
				<div className='main'>
					<h1 className='capitalize' style={{ fontSize: 'xx-large', color: 'darkblue', fontWeight: '800' }}>
						News Related to {this.state.type}
					</h1>
					<ul className='cards'>
						{/* {news} */}
						{this.state.news}
					</ul>
				</div>
				<Footer />
			</div>
		);
	}
}
export default withRouter(News);
